'use strict'

module.exports =
  buildTargetMetatag: (key, val) ->
    metatag = document.createElement('meta')
    metatag.setAttribute('name', 'ai-dfp-target')
    metatag.setAttribute('data-key', key)
    metatag.setAttribute('data-val', val)
    metatag

  rebuildTargeting: (targets) ->
    return unless targets?
    placementMetatag = Array.from(document.querySelectorAll('meta[name=ai-slot]')).slice(-1)[0]
    targetMetatags = Array.from(document.querySelectorAll('meta[name=ai-dfp-target]'))
    for targetMetatag in targetMetatags
      targetMetatag.remove()
    window.googletag.pubads().clearTargeting()
    for target in targets
      placementMetatag = placementMetatag.insertAdjacentElement 'afterEnd', @buildTargetMetatag(target.key, target.val)
      window.googletag.pubads().setTargeting(target.key, target.val)

  refresh: (hash) ->
    return unless hash? and window.googletag?.pubads?
    @rebuildTargeting hash.aiHeader?.dfpTargets
    window.googletag.pubads().refresh()